import def from "./def";

//Реакция на query параметры в запросе
export default function query(v) {
	const key = v.keys().find(e => def[e]) ?? 'bill';
	const fn = def[key];
	const res = fn(v);
	if (res) {
		window.history.replaceState(null, '', `${window.location.pathname}`);
	}
}